<template>
  <div
    class="border-bottom pointer hover-highlight z2-conv-item-container"
    :class="app.selectedConversationMessage?.lastMessageId == conversation.lastMessageId && 'active-highlight'"
    @click="onSelectConversation">
    <div class="px-12 py-12 pb-2 d-flex align-items-start">
      <div class="z2-avatar-container mt">
        <img
          class="z2-avatar"
          :src="avatar" />
        <div
          v-if="!conversation.pushNotify"
          class="z2-badge">
          <img
            src="/assets/icon/Mute.png"
            style="min-width: 18px; max-width: 18px; min-height: 18px; max-height: 18px" />
        </div>
        <div
          v-if="conversation.unreadCount && conversation.pushNotify"
          class="z2-badge">
          {{ conversation.unreadCount }}
        </div>
      </div>
      <div class="d-flex flex-column flex-1 ps-2 ms-1 justify-content-between">
        <div
          class="d-flex align-items-center justify-content-between"
          style="position: relative">
          <el-tooltip
            effect="dark"
            :content="nameConversation"
            placement="top">
            <span
              class="font-14 fw-500 name-conversation trim-text-1-line"
              :style="{ 'max-width': conversation.isPin ? '130px' : '146px' }">
              {{ nameConversation }}
            </span>
          </el-tooltip>
          <div class="d-flex justify-content-end align-items-center z2-conv-item-info">
            <span class="fw-300 font-12">
              {{ lastMessageTime }}
            </span>
            <img
              v-if="conversation.isPin"
              class="ms-1"
              src="/assets/icon/favourite.png" />

            <el-tooltip
              class="item"
              effect="dark"
              :content="nameAccount"
              placement="top">
              <div>
                <img
                  class="z2-avatar-small ms-1"
                  :src="avatarAccount" />
              </div>
            </el-tooltip>
          </div>
          <div
            class="pointer z2-menu-context-btn"
            @click="showMenu">
            <IconV2
              name="el-icon-more"
              color="#3484F0" />
          </div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="nameAccount"
            placement="top">
            <div class="pointer z2-avatar-tooltip">
              <img
                class="z2-avatar-small ms-1"
                :src="avatarAccount" />
            </div>
          </el-tooltip>
        </div>
        <div
          class="mt-1 font-14 trim-text-1-line max-width-222 mb-0 fw-400 text-grey600"
          v-html="highlightedText"></div>
      </div>
    </div>
    <ListTagEllipsis :tags="conversation.tags || []" />
  </div>
</template>

<script>
import dateUtil from "@/lib/date-util";
import ListTagEllipsis from "./ListTagEllipsis.vue";
import { removeVietnameseTones2, findFirstIndexInString } from "../lib/text-utils";

export default {
  props: ["active", "accounts", "conversation", "searchKey"],
  components: {
    ListTagEllipsis,
  },
  data() {
    return {
      isMenuVisible: false,
    };
  },
  watch: {
    conversation() {
      console.log(12312);
    },
  },
  computed: {
    avatar() {
      if (this.conversation.avatar) {
        return this.conversation.avatar;
      } else {
        return "/assets/images/no-avatar.png";
      }
    },
    nameConversation() {
      return this.conversation.swName ? this.conversation.swName : this.conversation.toName;
    },
    lastMessageTime() {
      return dateUtil.timestampToDate(this.conversation.lastMessageTime * 1000000);
    },
    isConversationDraft() {
      return this.app.draftMessageList[this.conversation.id]?.content;
    },
    avatarAccount() {
      let filter = this.accounts.filter((a) => a.accountId == this.conversation.accountId);
      if (filter && filter.length > 0) {
        return filter[0].avatar;
      }
      return "";
    },
    nameAccount() {
      let filter = this.accounts.filter((a) => a.accountId == this.conversation.accountId);
      if (filter && filter.length > 0) {
        return this.getAccountName(filter[0]);
      }
      return "";
    },
    conversationContent() {
      const conversationContent =
        (this.conversation.group ? (this.conversation.dname ? this.conversation.dname + ": " : "Bạn: ") : "") +
        this.lastConversationType(this.conversation.lastContent, this.conversation.lastMessageContent, this.conversation.lastMessageType);
      const splitArray = conversationContent.split(":");
      const firstPart = splitArray[0].trim();
      const userLast = splitArray[0].trim();
      const content = conversationContent.substring(firstPart.length + 1).trim();
      return {
        type: this.conversation.unreadCount ? "unread" : "readed",
        content: this.conversation.lastMessageContent,
        userLast: userLast,
        contentOnly: content,
      };
    },
    highlightedText() {
      const normalizedText = removeVietnameseTones2(this.conversation.lastMessageContent.toLowerCase());
      const normalizedSearchKey = removeVietnameseTones2(this.searchKey.toLowerCase());

      const searchTerms = normalizedSearchKey.split(" ");

      let highlightedText = this.conversation.lastMessageContent;

      let firstMatchIdx = -1;
      searchTerms.forEach((term) => {
        //   const regex = new RegExp(`(?<!\\w)${term}(?!\\w)`, "g");
        //   normalizedText.replace(regex, (match) => {
        //     const start = normalizedText.indexOf(removeVietnameseTones2(match).toLowerCase());
        //     firstMatchIdx = firstMatchIdx > -1 && firstMatchIdx <= start ? firstMatchIdx : start;
        //     const originalMatch = this.conversation.lastMessageContent.substr(start, match.length);
        //     highlightedText = highlightedText.replace(
        //       new RegExp(`(?<!\\w)${originalMatch}(?!\\w)`, "g"),
        //       `<span style="color: #1769D7 !important; font-weight: 500;">${originalMatch}</span>`
        //     );
        //     return match;
        //   });

        const start = findFirstIndexInString(normalizedText, term);
        firstMatchIdx = firstMatchIdx > -1 && firstMatchIdx <= start ? firstMatchIdx : start;
        const originalMatch = this.conversation.lastMessageContent.substr(start, term.length);
        highlightedText = highlightedText.replace(
          new RegExp(`(?<!\\w)${originalMatch}(?!\\w)`, "g"),
          `<span style="color: #1769D7 !important; font-weight: 500;">${originalMatch}</span>`
        );
      });

      return firstMatchIdx < 28 ? highlightedText : "... " + highlightedText.substr(firstMatchIdx, highlightedText.length);
    },
  },
  methods: {
    onSelectConversation() {
      this.$emit("onSelect", this.conversation);
    },
    showMenu(e) {
      this.$emit("showMenu", e);
      e.preventDefault();
      e.stopPropagation();
    },
  },
};
</script>

<style>
</style> 